module.exports = __webpack_public_path__ + "img/receipt36.fb5c67d7.svg";